import { FormHeading, FormItemWrapper, FormWrapper } from './styles'
import { Select, Textarea } from '@baseV2'
import GSTAddressCard from '../SelectGst/GSTAddressCard'
import { strings } from '@constants'

const GenerateEstimateForm = ({ formState, billingAddress, mbookGst, accountDetails, onChangeHandler }) => {
	return (
		<FormWrapper>
			<FormItemWrapper>
				<Select
					id='estimate-mbook-bank'
					label={formState?.account_detail?.label}
					placeholder={formState?.account_detail?.label}
					data={accountDetails}
					value={formState?.account_detail?.value || {}}
					primaryKey='account_number'
					displayKey='name'
					disabled={formState?.account_detail?.disabled}
					onChange={onChangeHandler('account_detail')}
				/>
			</FormItemWrapper>
			<FormItemWrapper>
				<Textarea
					id='estimate-remarks'
					label={formState?.remarks?.label}
					value={formState?.remarks?.value}
					disabled={formState?.remarks?.disabled}
					rows={6}
					onChange={(e) => onChangeHandler('remarks')(e.target.value)}
				/>
			</FormItemWrapper>
			<FormItemWrapper>
				<FormHeading>{strings(['mbook', 'gst'])}</FormHeading>
				<GSTAddressCard gst={mbookGst?.gst} address={mbookGst?.address} />
			</FormItemWrapper>
			<FormItemWrapper>
				<FormHeading>{strings(['billing', 'address'])}</FormHeading>
				<GSTAddressCard gst={billingAddress?.gst} address={billingAddress?.address} />
			</FormItemWrapper>
		</FormWrapper>
	)
}

export default GenerateEstimateForm
